
import riderDelivery from "~/assets/images/riderDelivery.svg";
export default {
  data() {
    return {
      riderDelivery
    };
  },
  props: {
    percentage: {
      type: Number,
      default: 0
    }
  },
  computed: {
    getProgressInPercentage() {
      return `${this.percentage}%`;
    }
  }
};
